/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import ServiceSupplier from '../../forms/serviceSupplier';
import restApiClient from '../../services/restApiClient';
import FilterTree from '../../helpers/filterTree';
import {
  Container,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  AddBox,
  StyledCrudTable,
  FormHelperText,
  Truck,
} from './styles';
import isEmpty from 'lodash/isEmpty';
import { Hidden } from '@material-ui/core';
import AdornedTextField from '../adornedTextField';

const SelectServiceSupplierDialogControl = ({
  data,
  className,
  id,
  enabled = true,
  uischema,
  schema,
  path,
  label,
  handleChange,
  onSuccess,
  config,
  errors,
  visible = true,
  disabled,
  required,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);
  const [selectedServiceSupplier, setSelectedServiceSupplier] = React.useState(
    {}
  );

  const handleClickOpen = () => {
    if (enabled) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState({ count: 0, values: [] });
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [orderBy, setOrderby] = useState({ socialName: 'asc' });
  const [searchBy, setSearchBy] = useState('');

  const columns = ServiceSupplier.tableSchema;

  useEffect(() => {
    restApiClient.serviceSupplier
      .getAll(
        rowsPerPage,
        page * rowsPerPage,
        searchBy
          ? new FilterTree()
              .and((leftOp, rightOp) => {
                leftOp.isNull('deletedAt');
                rightOp
                  .like('id', searchBy)
                  .or()
                  .like('socialName', searchBy)
                  .or()
                  .like('fantasyName', searchBy);
              })
              .toString()
          : new FilterTree().isNull('deletedAt').toString(),
        orderBy
      )
      .then((e) => {
        setRows(e.data);
      });
  }, [rowsPerPage, page, orderBy, searchBy]);

  useEffect(() => {
    if (data) {
      restApiClient.serviceSupplier.findById(data).then((e) => {
        setSelectedServiceSupplier(e.data);
      });
    } else {
      setSelectedServiceSupplier({});
    }
  }, [data]);

  return (
    <Hidden xsUp={!visible}>
      <Container>
        <AdornedTextField
          className={className}
          disabled={!enabled}
          error={!isEmpty(errors)}
          adornment={<Truck />}
          clickableAdornment
          onAdornmentClick={handleClickOpen}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={handleClickOpen}
          label={label ?? 'Fornecedor'}
          InputLabelProps={{
            readOnly: true,
          }}
          required={required}
          value={selectedServiceSupplier?.socialName ?? ''}
          helperText={
            !isEmpty(errors) ? (
              <FormHelperText error>{`${errors}`}</FormHelperText>
            ) : (
              ''
            )
          }
        />

        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={open}
          onClose={handleClose}
        >
          <DialogContent>
            <StyledCrudTable
              title={'Seleção de Fornecedor'}
              modelActions={ServiceSupplier.actions}
              columns={columns}
              rows={rows}
              page={page}
              setPage={(page) => setPage(page)}
              rowsPerPage={rowsPerPage}
              availableRowsPerPage={[3]}
              setRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
              onOrderByChange={(orderBy) => setOrderby(orderBy)}
              orderBy={orderBy}
              setOrderBy={(value) => setOrderby(value)}
              searchBy={searchBy}
              setSearchBy={(value) => setSearchBy(value)}
              actions={{
                insert: {
                  icon: <AddBox />,
                  onClick: (id, data) => {
                    setSelectedServiceSupplier(data);
                    handleChange?.(path, id);
                    onSuccess?.(id);
                    handleClose();
                  },
                  title: 'Vincular',
                  allowedActions: [ServiceSupplier.actions.getAll],
                },
              }}
              customCellRenderers={{
                fantasyName: {
                  renderer: (field, value) => {
                    return value ?? '-';
                  },
                },
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancelar
            </Button>
            <Button onClick={handleClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Hidden>
  );
};

export default SelectServiceSupplierDialogControl;
